module.exports = __webpack_public_path__ + "img/PG.132eec9e.svg";